/*
 * @Author: 肖玲
 * @Date: 2023-02-23 18:21:20
 * @LastEditTime: 2023-08-29 15:20:23
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\earlywarning-manage\early-warning-platform\modules\systemSettingsRouter.js
 * 系统设置管理
 */
const systemSettingsRouter = [
  // 系统配置
  {
    path: '/earlywarning-manage/early-warning-platform/system-setting/Page',
    name: 'EarlywarningSetting',
    component: () =>
      import(
        /*webpackChunkName:"doctorDataKpi" */
        '@/views/earlywarning-manage/early-warning-platform/system-setting/Page.vue'
      ), //
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '系统配置',
    },
  },

  {
    path: '/earlywarning-manage/early-warning-platform/system-setting/content-config',
    name: 'EarlywarningContentConfig',
    component: () =>
      import(
        /*webpackChunkName:"doctorDataKpi" */
        '@/views/earlywarning-manage/early-warning-platform/system-setting/content-config/Page.vue'
      ), //
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '预警反馈内容配置',
      breadcrumb: [
        {
          title: '系统设置',
          name: 'EarlywarningSetting',
        },
      ],
    },
  },

  {
    path: '/earlywarning-manage/early-warning-platform/system-setting/content-config/edit',
    name: 'EarlywarningContentConfigEdit',
    component: () =>
      import(
        /*webpackChunkName:"doctorDataKpi" */
        '@/views/earlywarning-manage/early-warning-platform/system-setting/content-config/Edit.vue'
      ), //
    meta: {
      SecondaryMenu: '系统设置', //二级菜单
      title: '编辑字段',
      breadcrumb: [
        {
          title: '系统设置',
          name: 'EarlywarningSetting',
        },
        {
          title: '预警反馈内容配置',
          name: 'EarlywarningContentConfig',
        },
      ],
    },
  },
]
export default systemSettingsRouter
